import React from 'react'
import { useNavigate } from 'react-router'
import { Base } from '@itsrever/design-system'
import { AppstoreintegrationspbIntegrationCard } from '@itsrever/rever-api'
import { UninstallDialog } from './uninstall-dialog'
import { formatTag } from '@/ui/components/integration-components/integrationsUtils'
import { useTranslation } from 'react-i18next'

interface AppCardProps {
  integration: AppstoreintegrationspbIntegrationCard
}

const InstalledAppCard: React.FC<AppCardProps> = ({ integration }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleCardClick = () => {
    navigate(`/account/integrations/details/${integration.integration_id}`, {
      state: {
        name: integration.integration_name
      }
    })
  }

  return (
    <>
      <Base.Card className="mt-4 flex h-auto flex-wrap items-center gap-3 overflow-hidden p-4">
        <img
          loading="lazy"
          src={integration.integration_logo}
          className="aspect-square w-[52px] shrink-0 rounded-lg object-contain"
          alt={`${integration.integration_name} logo`}
        />
        <div className="flex min-w-[240px] flex-1 shrink basis-0 flex-col justify-center max-md:max-w-full">
          <div className="text-xl font-medium leading-snug text-black">
            {integration.integration_name}
          </div>
          <div className="mt-1 flex w-full flex-col max-md:max-w-full">
            <div className="text-sm leading-none tracking-normal text-black max-md:max-w-full">
              {integration.integration_description}
            </div>
            <div className="mt-2 flex items-center gap-2 self-start text-xs font-medium uppercase leading-none tracking-wide text-neutral-700">
              {integration.integration_category_tags?.map((tag, index) => (
                <div
                  key={index}
                  className="my-auto gap-0.5 self-stretch overflow-hidden rounded-full bg-blue-200 px-3 py-0.5"
                >
                  {formatTag(tag)}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="flex gap-2">
          <Base.Button
            type="button"
            variant="secondary"
            onClick={handleCardClick}
          >
            {t('integrations_store.manage')}
          </Base.Button>
          <UninstallDialog integration={integration} />
        </div>
      </Base.Card>
    </>
  )
}

export default InstalledAppCard
